import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subject, takeUntil, finalize } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { RewardsV1Component } from './components/rewards-v1/rewards-v1.component';
import { RewardsV2Component } from './components/rewards-v2/rewards-v2.component';

@Component({
  selector: 'app-rewards',
  standalone: true,
  imports: [CommonModule, RouterModule, RewardsV1Component, RewardsV2Component],
  templateUrl: './rewards.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./rewards.component.scss'],
})
export class RewardsComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  isConfigLoading = true;
  rewardsV2Enabled = false;

  constructor(private readonly appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.loadAppConfig();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadAppConfig(): void {
    this.appConfigService
      .getAppConfig()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.isConfigLoading = false))
      )
      .subscribe({
        next: config => {
          this.rewardsV2Enabled = config.rewardsV2Enabled === true;
        },
        error: () => {
          this.rewardsV2Enabled = false;
        },
      });
  }
}
